import React from "react";
import "./ComputingWhat.css";
import img from "../computingassets/whatimg.png";

export default function ComputingWhat() {
  return (
    <div id="computing-what" className="outsourcemainclass">
      <div className="left">
        <img src={img} alt="error" />
      </div>
      <div className="right">
        <h2>What Is Configuration Management?</h2>
        <p>
          Configuration Management is a DevOps practice that involves defining,
          managing, and maintaining system configurations in a consistent and
          automated manner. It ensures that servers, applications, and
          infrastructure components remain aligned with defined standards,
          reducing errors, downtime, and operational risks.
        </p>
      </div>
    </div>
  );
}
